import { Skeleton, Card } from "@mui/material";
import { Table } from "antd";
import "../../pages/MyTeam/Users.css";

/* Mirrors the real table's three columns and alignment so the layout does
   not shift when loading finishes. */
const columns = [
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    align: "left",
    render: () => <Skeleton variant="text" width="80%" />,
  },
  {
    title: "Role",
    key: "role",
    align: "left",
    width: 140,
    render: () => (
      <Skeleton variant="rounded" width={64} height={22} sx={{ borderRadius: 999 }} />
    ),
  },
  {
    title: "Action",
    key: "action",
    align: "left",
    width: 160,
    render: () => <Skeleton variant="rectangular" width={90} height={32} />,
  },
];

const dataSource = Array.from({ length: 3 }).map((_, index) => ({
  key: index,
  _id: `skeleton-${index}`,
}));

const UserTableSkeleton = () => {
  return (
    <div className="users-page">
      <div className="users-container">
        {/* Mirrors the loaded page shape (header + stat strip + table card)
            so nothing shifts position when data arrives. */}
        <header className="page-head">
          <div className="page-head-text">
            <Skeleton variant="text" width={140} height={32} />
            <Skeleton variant="text" width={230} height={18} />
          </div>
          <Skeleton variant="rounded" width={120} height={38} />
        </header>

        <div className="stat-row">
          {Array.from({ length: 3 }).map((_, i) => (
            /* Mirrors the real card: small label bar on top, the figure
               below. A skeleton shaped unlike what replaces it makes the
               page jump the moment data lands. */
            <div className="stat-tile" key={i}>
              <Skeleton variant="text" width={92} height={14} />
              <Skeleton variant="text" width={56} height={40} />
            </div>
          ))}
        </div>

        <Card
          style={{ width: "100%" }}
        >
          <Table
            columns={columns}
            dataSource={dataSource}
            rowKey="_id"
            pagination={false}
            bordered
          />
        </Card>
      </div>
    </div>
  );
};

export default UserTableSkeleton;
